module.exports = __webpack_public_path__ + "img/gluten_free.bee7f083.jpg";